import { TYPE } from '@/constants';
import Model, { ModelParams } from '../model';
import CircleSection from './circle';
import RectangularSection from './rect';
import PolygonalSection from './polygon';
import { SomeRequired } from '@/core/typeHelper';
import Application from '@/core/application';
import PathSection from './path';

const sections = {
  [TYPE.POLYGON]: PolygonalSection,
  [TYPE.RECT]: RectangularSection,
  [TYPE.CIRCLE]: CircleSection,
  [TYPE.PATH]: PathSection,
};

export default class SectionHelper {
  static create(
    type: typeof TYPE.POLYGON | typeof TYPE.RECT | typeof TYPE.CIRCLE | typeof TYPE.PATH,
    params: ModelParams
  ) {
    return sections[type].create(params);
  }

  static clone(
    unit: PolygonalSection | RectangularSection | CircleSection | PathSection,
    options: { keepPosition?: boolean } = {}
  ) {
    const { keepPosition } = options;
    const json = unit.toJSON() as SomeRequired<ModelParams, 'type'>;
    if (!keepPosition) {
      if (unit.subtype === TYPE.POLYGON) {
        json.attributes.transform.e += 50;
        json.attributes.transform.f += 50;
      } else {
        json.attributes.position[0] += 50;
        json.attributes.position[1] += 50;
      }
    }

    if (json.attributes.serverSectionId) {
      delete json.attributes.serverSectionId;
      json.attributes.categoryId = null;
    }

    if (json.attributes.ga === true && Application.instance.props.oneCatPerGa) {
      json.attributes.categoryId = null;
    }

    json.uuid = Model.getUniqueIdStatic(json.type);
    return sections[unit.subtype].fromJSON(json);
  }

  static fromJSON(params: ModelParams) {
    params.subtype = params.subtype ? params.subtype : 'polygon';
    return SectionHelper.create(params.subtype as 'circle' | 'rect' | 'polygon', params);
  }
}
